export default "__VITE_ASSET__CtugowDV__"